import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import About from "../../components/LandingPage/About";
import ScientificProgram from "../../components/LandingPage/ScientificProgram";
import Speaker from "../../components/LandingPage/Speaker";
import PosterGuide from "../../components/LandingPage/PosterGuide";
import Partner from "../../components/LandingPage/Partner";
import Venue from "../../components/LandingPage/Venue";

const LandingPageIndex = () => {
  const { hash } = useLocation();

 useEffect(() => {
  if (hash) {
    // 1. Pastikan id hasil replace juga dipaksa lowercase
    const id = hash.replace("#", "").toLowerCase(); 
    // 2. Naikkan delay ke 800ms atau 1000ms untuk memastikan 
    const timeoutId = setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        console.log("Mencari ID:", id, "Hasil:", element); 
      }
    }, 800); 
    return () => clearTimeout(timeoutId);
  }
}, [hash]);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-y-8 pt-8 pb-0">
      <About />
      <ScientificProgram bgColor="#F8FAFC" />
      <Speaker /> 
      <PosterGuide bgColor="#F8FAFC"/>
      <Partner />
      <Venue bgColor="#F8FAFC" /> 
    </main>
  );
};

export default LandingPageIndex;